export default {
  basicData: {
    educationalLevel: '',
    estadoCivil: '',
    celular: ''
  },
  creditData: {
    lineaCredito: {
      nombre: ''
    },
    fields: [{ id: 0, entidad: '', monto: '', valorCuota: '', fechaVencimiento: '', noObligacion: '', 
      entidad: { 
        nombre: '',
        show: false
      }
    }],
    credits: {}
  },
  workData: {
    pagaduria: '',
    ciudad: '',
    tipoDocumento: '',
    branch: '',
    telefonoOficina: '',
    cargo: '',
    certificacionLaboral: [],
  },
  complementData: {
    idTipo: 'CC',
    segmento: {
      nombre: ''
    },
    actividad: '',
    pagaduria: '',
    ciudad: '',
  },
  aditionalData: {
    departamento: '',
    ciudad: '',
    extraDepartamento: '',
    extraCiudad: '',
    estrato: '',
    tieneVehiculo: { label: 'No', value: false },
    correspondencia: { label: 'Residencia', value: 'residencia' }
  },
  credit: {},
  solicitation: {
    cliente: {
      nombres: '',
      tipoIdentificacion: '',
      identificacion: '',
      celular: ''
    }
  }
}
